import { Typography, styled, List, Box, Avatar } from "@mui/material";
import { AlertAndTime as A1 } from "@/gen/api/backup";
import { AlertAndTime as A2 } from "@/gen/api/encrypt";
import { AlertAndTime as A3 } from "@/gen/api/deploy";
import BoltIcon from '@mui/icons-material/Bolt';
import WarningIcon from '@mui/icons-material/Warning';


export const AlertList = styled(List)(({ theme }) => ({
  paddingTop: 0,
  minHeight: 180,
  '& .MuiListItem-root, & .MuiListItem-root > a': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '& .MuiAvatar-root': {
    width: 35,
    height: 35,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  '& .MuiListItemText-root': {
    marginLeft: theme.spacing(2),
    marginTop: 0,
    marginBottom: 0,

    '& > p.error': { color: theme.palette.error.main },
    '& > p.warning': { color: theme.palette.mode === 'dark' ? theme.palette.warning.main : '#ad6305' },
    '& > span.error': { color: theme.palette.mode === 'dark' ? theme.palette.error.light : theme.palette.error.dark },
    '& > span.warning': { color: theme.palette.mode === 'dark' ? theme.palette.warning.light : theme.palette.warning.dark },
  },
}))

export const NoAlerts = () =>
  <Box
    sx={{ height: '180px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}
  >
    <Typography
      variant="h6"
      sx={theme => ({
        color: theme.palette.mode === 'dark' ? 'success.main' : '#28871d'
      })}
    >
      No Alerts
    </Typography>
  </Box>

export const AlertIcon = ({isWarning}: { isWarning?: boolean }) => 
  !isWarning ?
  <Avatar sx={{ '&.MuiAvatar-root': { bgcolor: 'error.main' }}}>
    <BoltIcon fontSize="large" />
  </Avatar> :
  <Box>
    <WarningIcon fontSize="large" sx={{ color: 'warning.main' }}/>
  </Box>


interface Emphasis { pos: number }
type ParsedToken = string | Emphasis

const parse = (i:number, str:string): ParsedToken[] => {
  const placeholder = `[#!${i}]`
  const parsed = str.split(placeholder).flatMap(s => [s, {pos: i}])
  parsed.length = parsed.length - 1
  return parsed
}

type AlertAndTime = A1 | A2 | A3;

export const displayAlert = (alert: AlertAndTime) => {  
  const tokens = [...Array(alert.parameters?.length || 0).keys()].reduce((acc, i) => {
    const arr: ParsedToken[] = []
    for(const n in acc) {
      const t = acc[n]
      if (typeof(t) === 'string') {
        arr.push.apply(arr, parse(i, t))
      } else {
        arr.push(t)
      }
    }
    return arr
  }, [alert.alert || ''] as ParsedToken[])
  return (
    <>
      {tokens.map((t, i) => 
        typeof(t) === 'string'
        ? <span key={t}>{t}</span>
        : <Typography 
            key={i + '' + t.pos}
            component="span"
            variant="subtitle2"
          >
            {(alert.parameters || [])[t.pos]}
          </Typography>
      )}
    </>
  )
}
